import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { ReplaySubject, Subject } from 'rxjs/';

import { CommunicationService } from './communication.service';
import { GroupService } from './group.service';

import { Invite } from '../models/invite';
import { Study } from '../models/study';
import { BasicError } from '../models/error/error';

@Injectable()
export class InviteService {

  /**
   * All Vars for get my invitations
   */
  private myInvitationsUrl = '/api/v1/my/invitations';
  private invitationActivationUrl = '/api/v1/studies/invitation/';

  constructor(private communication: CommunicationService, private groupService: GroupService) { }

  public getMyInvitations(): Subject<any> {
    const retReplay = new Subject();

    this.communication.get(this.myInvitationsUrl).subscribe(json => {
      // An Error occurred
      if (json instanceof BasicError) {
        console.log('---InviteService---: Getting my Invitations failed.');
        retReplay.next(json);
      } else {
        // No Error occurred
        const retArray: Invite[] = [];

        for (let i = 0; i < json.data.length; i++) {
          const stdJSON = json.data[i];
          const invite = new Invite(stdJSON.id);
          if (stdJSON.attributes.model_id) { invite.setModelId(stdJSON.attributes.model_id); }
          if (stdJSON.attributes.expires_at) { invite.setExpiresAt(stdJSON.attributes.expires_at); }

          if (stdJSON.attributes.uri) {
            const parts = stdJSON.attributes.uri.split('/');
            const id = parts[(parts.length - 1)];
            invite.setInvitationId(id);
          }

          retArray.push(invite);
        }
        retReplay.next(retArray);
      }
    });

    return retReplay;
  }

  /**
   * Accept an invitation
   * @param invite invitation to accept
   */
  public acceptInvitation(invite: Invite): Subject<any> {
    const retReplay = new Subject();

    const url = this.invitationActivationUrl + invite.getInvitationId();

    this.communication.post(url, {}).subscribe(json => {
      if (json instanceof BasicError) {
        console.log(json);
        console.log(url);
        retReplay.next(false);
      } else {
        retReplay.next(true);
      }
    });

    return retReplay;
  }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/services/invite.service.ts